var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0.62);}.b{clip-path:url(#a);}.c{fill:#a2fdfa;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 110,
    height: 110,
    transform: "translate(1822 234)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-1822 -234)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1319.31 -264.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(537.69 512.85)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M571.343,559.976l-.229-.2v-33.7a13.229,13.229,0,1,0-26.459,0v33.7l-.229.2a20.116,20.116,0,1,0,33.653,14.8A19.8,19.8,0,0,0,571.343,559.976Zm-13.443,29.4a14.622,14.622,0,0,1-14.6-14.6,13.732,13.732,0,0,1,6.965-12.254V526.064a7.651,7.651,0,1,1,15.3,0v36.488a14.465,14.465,0,0,1-7.666,26.825Z",
    transform: "translate(-537.69 -512.85)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M557.571,553.731l-.472-.152V535.67h-5.594v17.909l-.473.152a9.407,9.407,0,0,0-6.493,9.084,9.754,9.754,0,1,0,19.509,0A9.413,9.413,0,0,0,557.571,553.731Z",
    transform: "translate(3.59 11.961)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.1946b7703947e6a8ea73d520681c1770.svg";
export { ForwardRef as ReactComponent };